import axios from "axios";
import { isTokenExpired } from "../utils/token";

const API_BASE_URL = process.env.REACT_APP_BACKEND_API_URL;

const client = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

client.interceptors.request.use((config) => {
  const token = localStorage.getItem("Appusertoken");
  if (token && !isTokenExpired(token)) {
    config.headers = {
      ...config.headers,
      Authorization: `Bearer ${token}`,
    };
  } else if (token) {
    localStorage.removeItem("Appusertoken");
    localStorage.removeItem("AppusertokenExpiresAt");
  }
  return config;
});

export const getApiErrorMessage = (error) => {
  if (!error) {
    return "Request failed";
  }

  const responseData = error.response?.data;
  if (!responseData) {
    return error.message || "Request failed";
  }

  if (typeof responseData === "string") {
    return responseData;
  }

  if (typeof responseData?.message === "string") {
    return responseData.message;
  }

  if (typeof responseData?.error?.message === "string") {
    return responseData.error.message;
  }

  return "Request failed";
};

export default client;
